import { ThemeUIStyleObject } from 'theme-ui';

export const cardStyles: ThemeUIStyleObject = {
  backgroundColor: 'neutral/000',
  borderRadius: '0.5rem',
  padding: '1.5rem',
  boxShadow: 'small',
  cursor: 'pointer',
  transition: 'all 0.2s ease',
  display: 'flex',
  flexDirection: 'column',
  gap: '0.75rem',
  minHeight: '240px',
  
  '&:hover': {
    boxShadow: 'medium',
    transform: 'translateY(-2px)',
  },
};

export const nameStyles: ThemeUIStyleObject = {
  fontSize: '1.125rem',
  fontWeight: 700,
  color: 'neutral/800',
  margin: 0,
};

export const emailStyles: ThemeUIStyleObject = {
  fontSize: '0.875rem',
  color: 'neutral/600',
  margin: 0,
};

export const infoRowStyles: ThemeUIStyleObject = {
  display: 'flex',
  flexDirection: 'column',
  gap: '0.25rem',
};

export const labelStyles: ThemeUIStyleObject = {
  fontSize: '0.75rem',
  color: 'neutral/500',
  fontWeight: 600,
  textTransform: 'uppercase',
  letterSpacing: '0.05em',
};

export const valueStyles: ThemeUIStyleObject = {
  fontSize: '0.875rem',
  color: 'neutral/700',
};

export const badgeContainerStyles: ThemeUIStyleObject = {
  display: 'flex',
  gap: '0.5rem',
  flexWrap: 'wrap',
  marginTop: '0.5rem',
};

export const badgeStyles: ThemeUIStyleObject = {
  fontSize: '0.75rem',
  padding: '0.25rem 0.5rem',
  borderRadius: '0.25rem',
  fontWeight: 600,
};

export const inactiveBadgeStyles: ThemeUIStyleObject = {
  ...badgeStyles,
  backgroundColor: 'neutral/200',
  color: 'neutral/700',
};

export const managerBadgeStyles: ThemeUIStyleObject = {
  ...badgeStyles,
  backgroundColor: '#e6f7ff',
  color: '#0c7e96',
};

export const executiveBadgeStyles: ThemeUIStyleObject = {
  ...badgeStyles,
  backgroundColor: '#fff7e6',
  color: '#d46b08',
};
